import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import Container from '@material-ui/core/Container';
import Grid from '@material-ui/core/Grid';
import GuestLayout from '../../layouts/guest';
import useStyles from './styles';

const Deleted: FC = () => {
  const css = useStyles();
  const { t } = useTranslation();

  return (
    <GuestLayout>
      <Container className={css.container}>
        <Grid container>
          <Grid item xs={12} sm={12} md={6}>
            <h1 className="title">{t('deleted.title')}</h1>
            <div className={css.message}>{t('deleted.message')}</div>
          </Grid>
        </Grid>
      </Container>
    </GuestLayout>
  );
};

export default Deleted;
